import type { TabsProps } from '.';
import type { TabListProps, TabPanelProps } from './components';

export const getTabListItemsByTabs = (tabs: TabsProps['tabs']): TabListProps['tabListItems'] =>
    tabs.map((tab) => ({ children: tab.head, disabled: !tab.content }));

export const getTabPanelItemsByTabs = (tabs: TabsProps['tabs']): TabPanelProps['tabPanelItems'] =>
    tabs.map((tab) => tab.content);
